<template>
  <div class="all_info_container">
    <div class="center_container_box">
      <div class="crumbs">
        <span>{{ $t('lang.external.personal.当前位置：个人中心') }} > </span>
        <span> {{ $t(current) }} </span>
        <span v-if="crumbs"> > {{ crumbs }} </span>
      </div>
      <div class="main">
        <navLeft @change="changeCurrent" />
        <navRightShow />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import navLeft from './nav_left/nav_left'
import navRightShow from './nav_right_show/nav_right_show'
export default {
  components: {
    navLeft,
    navRightShow,
  },
  data() {
    return {
      current: '实验成绩',
    }
  },
  computed: {
    ...mapState(['crumbs']),
  },
  methods: {
    changeCurrent(val) {
      this.current = val
    },
  },
}
</script>
<style lang="scss" scoped>
.center_container_box {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 10px;
  min-height: 447px;
  overflow: hidden;
  .crumbs {
    color: #666666;
    font-size: 14px;
    line-height: 60px;
    padding: 0 5px;
    span {
      &:last-child {
        color: #444;
      }
    }
  }
  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
</style>